<template>
  <div class="common-subject-filter">
    <v-card flat class="pa-2 mt-2">
      <v-card-title>
        <v-progress-circular indeterminate color="orange" v-if="loading"></v-progress-circular>        
         <!-- <h3 v-if="!loading && profile && profile.club "> -->
          <h3>
         {{title}}
         </h3>      
        <v-spacer></v-spacer>        
        <div>
         <GoBackBtn/>
        </div>
      </v-card-title>     
    </v-card>
  </div>
</template>


<script>

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import GoBackBtn from "@/components/shared/GoBackBtn";

export default {
  name: "PageTitle",
  components: {GoBackBtn },
  props: {
    title: String,
    canChange: Boolean
  },

  data: function() {
    return {
      loading: false,
      changeExamSubject: false,
      exam: null,
      subject: null,
      examList: [],
      role: localStorage.getItem('role') || null,
    };
  },

  computed: {
    ...mapGetters({
      profile:"profile"
    })
  },
 
};
</script>
<style>
#subject-filter .v-toolbar {
  box-shadow: none;
}
</style>
